module.exports = __webpack_public_path__ + "img/mascotas.e3e2af4a.svg";